import { GT_OSGB, GT_WGS84 } from '../geotools';
import * as settings from '../settings.js';
import { Styles } from '../classes/Styles';
import { colors } from '../state';

const styles = new Styles();

Proj4js.defs['EPSG:27700'] =
  '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +datum=OSGB36 +units=m +no_defs';

let matrixIds = [];
for (let i = 0; i < 26; ++i) {
  matrixIds[i] = `EPSG:27700:${i}`;
}
const wmsDef = {
  title: 'Features',
  format: new OpenLayers.Format.JSON(),
  projection: new OpenLayers.Projection('EPSG:27700'),
  infoFormat: 'application/json',
  queryVisible: true,
  layers: ['listed_buildings'],
};

const defaultOptions = {
  format: 'image/png',
  isBaseLayer: true,
  projection: new OpenLayers.Projection('EPSG:27700'),
  maxExtent: [0, 0, 1400000, 1600000],
  opacity: 1,
  singleTile: false,
  wrapDateLine: false,
  transitionEffect: 'resize',
  renderers: ['Canvas'],
};
const ol = {
  popup: null,
  baseMaps: [
    'vmlLayer',
    'vmlLayerBW',
    'omlLayer',
    'omlLayerBW',
    'vmdLayer',
    'vmdLayerBW',
    'mmLayer',
    'bwLayer',
    'aerialLayer',
    'OSopen',
  ],
  vectorList: [
    'vector',
    'vectorOverview',
    'vectorPin',
    'error',
    'planningLayer',
    'lineSearchLayer',
    'vector2',
    'vectorSel',
    'vectorSelCombined',
    'tempMarkup',
  ],
  layers: {
    vmlLayer: new OpenLayers.Layer.WMS(
      'VML',
      settings.wmsServer,
      {
        layers: settings.wmslayers.vml,
        transparent: false,
        cleanup: 1,
      },
      defaultOptions,
    ),
    vmlLayerBW: new OpenLayers.Layer.WMS(
      'VMLBW',
      settings.wmsServer,
      {
        layers: settings.wmslayers.vmlbw,
        transparent: false,
        cleanup: 1,
      },
      defaultOptions,
    ),
    omlLayer: new OpenLayers.Layer.WMS(
      'OMLBW',
      settings.wmsServer,
      {
        layers: settings.wmslayers.vml,
        transparent: false,
        cleanup: 1,
      },
      defaultOptions,
    ),
    omlLayerBW: new OpenLayers.Layer.WMS(
      'OMLBW',
      settings.wmsServer,
      {
        layers: settings.wmslayers.vmlbw,
        transparent: false,
        cleanup: 1,
      },
      defaultOptions,
    ),
    vmdLayer: new OpenLayers.Layer.WMS(
      'VMD',
      settings.wmsServer,
      {
        layers: settings.wmslayers.vmd,
        transparent: false,
        cleanup: 1,
      },
      defaultOptions,
    ),
    vmdLayerBW: new OpenLayers.Layer.WMS(
      'VMDBW',
      settings.wmsServer,
      {
        layers: settings.wmslayers.vmdbw,
        transparent: false,
        cleanup: 1,
      },
      defaultOptions,
    ),
    mmLayer: new OpenLayers.Layer.WMS(
      'Mastermap Background',
      settings.wmsServer,
      {
        layers: settings.wmslayers.mastermap,
        transparent: false,
        cleanup: 1,
      },
      defaultOptions,
    ),
    bwLayer: new OpenLayers.Layer.WMS(
      'Mastermap Background BW',
      settings.wmsServer,
      {
        layers: settings.wmslayers.mastermapbw,
        transparent: false,
        cleanup: 1,
      },
      defaultOptions,
    ),
    aerialLayer: new OpenLayers.Layer.WMS(
      'Aerial',
      settings.wmsServer,
      {
        layers: 'OS:Getmapping',
        transparent: false,
      },
      defaultOptions,
    ),
    OSopen: new OpenLayers.Layer.WMTS({
      name: 'OS',
      url: 'https://api.os.uk/maps/raster/v1/wmts?key=MKeGrpR1WWNGgOYveb6vGeMrbsdstaRv',
      layer: 'Road_27700',
      format: 'image/png',
      matrixIds: matrixIds,
      matrixSet: 'EPSG:27700',
      style: 'default',
      isBaseLayer: true,
      opacity: 1,
    }),
    vector: null,
    vectorOverview: null,
    vector2: null,
    vectorSel: null,
    tempMarkup: null,
    vectorSelCombined: null,
    wfs: new OpenLayers.Layer.Vector('MMap WFS', {
      isBaseLayer: false,
      projection: new OpenLayers.Projection('EPSG:27700'),
      strategies: [new OpenLayers.Strategy.BBOX()],
      maxResolution: 0.21875,
      protocol: new OpenLayers.Protocol.WFS({
        version: '1.1.0',
        url: 'https://sacomm2.inverherive.co.uk/geoserver/wms',
        featurePrefix: 'OS',
        srsName: 'EPSG:27700',
        featureType: 'vw_os_mmap_topoarea_land_live',
      }),
      styleMap: styles.wfsstyleMap,
    }),
    vectorPin: null,
    error: null,
    planningLayer: null,
    lineSearchLayer: null,
    shadowMap: null,
    filtlayer: null,
  },
  controls: {
    click: null,
    dragmarker: null,
    doubleClick: null,
    modifyLR: null,
    modifyFeature: null,
    mousePositionCtrl: null,
    wfsInfo: new OpenLayers.Control.GetFeature({
      protocol: new OpenLayers.Protocol.WFS({
        version: '1.1.0',
        url: 'https://sacomm2.inverherive.co.uk/geoserver/wms',
        featurePrefix: 'OS',
        srsName: 'EPSG:27700',
        featureType: 'vw_os_mmap_topoarea_land_live',
        outputFormat: 'JSON',
      }),
      format: new OpenLayers.Format.JSON(),
      maxFeatures: 50,
      projection: new OpenLayers.Projection('EPSG:27700'),
      infoFormat: 'application/json',
      multipleKey: 'shiftKey',
      toggleKey: 'ctrlKey',
      single: true,
    }),
    wmsInfo2: new OpenLayers.Control.WMSGetFeatureInfo({
      url: settings.layerServer2,
      layerUrls: [settings.layerServer2],
      ...wmsDef,
    }),
    wmsInfo3: new OpenLayers.Control.WMSGetFeatureInfo({
      url: settings.layerProxy,
      layerUrls: [settings.layerProxy],
      ...wmsDef,
    }),
    addPoly: null,
    addPath: null,
    polyTitle: null,
    snap: null,
  },
  arrays: {
    heldLayers: [],
    addedLayers: [],
    addedWFSLayers: [],
    addedWFSOlLayers: [],
    addedOlLayers: [],
    queryOlLayers: [],
    queryLayers: [],
    wmsArray: [],
    wmsFeatureArray: [],
    newBoundaries: [],
    newLayers: [],
    fontSizes: [0, 0, 1, 4, 8, 16, 32, 66],
  },
  points: {
    marker: null,
    markerSV: null,
    marker2: null,
    error: [],
  },
  osgb: null,
  map: '',
  resolutions: [896, 448, 224, 112, 56, 28, 14, 7, 3.5, 1.75, 0.875, 0.4375, 0.21875, 0.109375, 0.0546875, 0.02734375],
  overviewSpacing: [50000, 20000, 10000, 5000, 3000, 1000, 500, 250, 125, 100, 100, 100, 100, 100, 100, 100],
  functions: {
    parent: this,
    setIndexes: () => {
      const { map, layers } = ol;
      map.setLayerIndex(ol.layers.mmLayer, 0);
      map.setLayerIndex(ol.layers.omlLayer, 1);
      map.setLayerIndex(ol.layers.vmlLayer, 2);
      map.setLayerIndex(ol.layers.vmdLayer, 3);
      map.setLayerIndex(ol.layers.vectorPin, 99);
      map.setLayerIndex(ol.layers.error, 100);
      map.setBaseLayer(ol.layers.mmLayer);
      layers.vector.setZIndex(1000);
      layers.vector2.setZIndex(1001);
      layers.planningLayer.setZIndex(2007);
      layers.lineSearchLayer.setZIndex(2008);
      layers.tempMarkup.setZIndex(1006);
      layers.vectorSel.setZIndex(1002);
      layers.wfs.setZIndex(1003);
      layers.vectorPin.setZIndex(2006);
      layers.error.setZIndex(2007);
      layers.vectorSel.setVisibility(false);
      layers.vectorSelCombined.setVisibility(false);
    },
    getGeomJSON: layer => {
      const json = new OpenLayers.Format.GeoJSON();
      const arr = [];
      for (let i = 0; i < layer.features.length; i++) {
        const obj = {};
        obj.geom = json.write(layer.features[i]);
        obj.style = JSON.stringify(layer.features[i].style);
        arr.push(obj);
      }
      return JSON.stringify(arr);
    },
    goHome: ({ state }) => {
      ol.map.restrictedExtent = null;
      ol.map.setCenter(new OpenLayers.LonLat(state.initx, state.inity));
      ol.map.restrictedExtent = new OpenLayers.Bounds(
        state.initx - 5162,
        state.inity - 5162,
        state.initx + 5162,
        state.inity + 5162,
      );
    },
    getOSGB: ({ point }) => {
      const conv = new GT_WGS84();
      conv.setGridCoordinates(point.lon, point.lat);
      return conv.getOSGB();
    },
    getWGS: ({ point }) => {
      const conv = new GT_OSGB();
      conv.setDegrees(point.lat, point.lon);
      return conv.getWGS84();
    },
    getVectorExtent: extent => {
      const x = extent.right - extent.left;
      const y = extent.top - extent.bottom;
      const xMid = extent.left + x / 2;
      const yMid = extent.bottom + y / 2;
      let xDist = x / 16;
      let yDist = y / 9;
      if (xDist < yDist) {
        xDist = (yDist * 16) / 1.8;
        yDist = (yDist * 9) / 1.8;
      } else {
        yDist = (xDist * 9) / 1.8;
        xDist = (xDist * 16) / 1.8;
      }
      const str =
        (xMid - xDist).toString() +
        ',' +
        (yMid - yDist).toString() +
        ',' +
        (xMid + xDist).toString() +
        ',' +
        (yMid + yDist).toString();
      const ext = {
        left: xMid - xDist,
        bottom: yMid - yDist,
        right: xMid + xDist,
        top: yMid + yDist,
      };
      return { extentString: str, extent: ext };
    },
    setUpOverview: (feats, zLevel = ol.map.getZoom()) => {
      if (feats && feats.length) {
        ol.layers.vectorOverview.destroyFeatures();
        let collection = [];
        feats.forEach(f => {
          if (!collection.length) collection[0] = [f];
          else {
            const added = collection.some(group => {
              return group.some(c => {
                const cc = c.geometry.getCentroid();
                const fc = f.geometry.getCentroid();
                if (
                  Math.abs(cc.x - fc.x) < ol.overviewSpacing[zLevel] &&
                  Math.abs(cc.y - fc.y) < ol.overviewSpacing[zLevel]
                ) {
                  group.push(f);
                  return true;
                }
              });
            });
            if (!added) collection[collection.length] = [f];
          }
        });
        collection.forEach(g => {
          const f = g[0];
          if (f.geometry) {
            const newStyle = {};
            jQuery.extend(newStyle, styles.defaultStyle);
            const point = new OpenLayers.Geometry.Point(f.geometry.getCentroid().x, f.geometry.getCentroid().y);
            const feat = new OpenLayers.Feature.Vector(
              point,
              null,
              styles.augment(newStyle, colors.white, 2, 1, colors.white),
            );
            feat.group = g;
            feat.style.pointRadius = '16';
            feat.style.label = g.length.toString();
            feat.style.labelAlign = 'cm';
            feat.style.fontColor = colors.black;
            feat.style.fontSize = '12px';
            feat.style.fontFamily = 'Arial';
            feat.style.fontWeight = 'bold';
            feat.attributes = f.attributes;
            feat.style.strokeColor = colors.black;
            feat.style.fillColor = '#ff844e';
            feat.style.fillOpacity = 0.75;
            feat.style.strokeWidth = 1;
            ol.layers.vectorOverview.addFeatures([feat]);
          }
          ol.layers.vectorOverview.redraw();
        });
      }
    },

    getFeaturesJSON: (safe, layer, layer2, flat = false) => {
      console.log(`flat: ${flat}`);
      if (!layer) layer = ol.layers.vector;
      if (!safe) safe = false;
      const geojson = new OpenLayers.Format.GeoJSON();
      $.each(layer.features, function (idx, feat) {
        if (feat.style) {
          feat.attributes.overlays = ol.arrays.addedLayers.concat(ol.arrays.addedWFSLayers).join('|');
          feat.attributes.color = feat.style.strokeColor;
          feat.attributes.fillColor = feat.style.fillColor;
          feat.attributes.fillOpacity = feat.style.fillOpacity;
        }
      });
      let json;
      if (layer2) {
        json = geojson.write(layer.features.concat(layer2.features));
      } else {
        json = geojson.write(layer.features);
      }
      const jjson = JSON.parse(json);
      if (jjson.features) {
        jjson.features = jjson.features.filter(function (feat) {
          return feat.geometry.type !== 'Point';
        });
      }
      jjson.features = jjson.features.map(function (feat) {
        if (flat && feat.properties.corporate) {
          feat.properties.corporate.forEach((c, idx) => {
            Object.keys(c).forEach(key => {
              feat.properties[`ccod_${idx + 1}_${key}`] = c[key];
            });
          });
          delete feat.properties.corporate;
        }
        if (flat && feat.properties.overseas) {
          feat.properties.overseas.forEach((c, idx) => {
            Object.keys(c).forEach(key => {
              feat.properties[`ocod_${idx + 1}_${key}`] = c[key];
            });
          });
          delete feat.properties.overseas;
        }
        if (feat.geometry.type === 'MultiPolygon') {
          feat.geometry.coordinates[0] = feat.geometry.coordinates[0].filter(function (c) {
            return c.length > 2;
          });
          return feat;
        } else return feat;
      });
      jjson.center = ol.map.getCenter();
      json = JSON.stringify(jjson);
      if (safe) {
        json = JSON.stringify(String(json));
        json = json.substring(1, json.length - 1);
      }
      return json;
    },
  },
};
export default ol;
